import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as i } from "react";
import { I as l } from "../../../../IconBase-CxZyIWw2.js";
const o = i((a, e) => /* @__PURE__ */ s.jsx(
  l,
  {
    ref: e,
    ...a,
    image: (r) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...r,
        children: [
          /* @__PURE__ */ s.jsx(
            "mask",
            {
              id: "mask0_2974_3572",
              width: 16,
              height: 12,
              x: 0,
              y: 2,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ s.jsx(
                "path",
                {
                  fill: "currentColor",
                  d: "M14.8 2H1.2c-.68 0-.88.46-.93.6-.04.14-.15.63.4 1.03L7.2 8.32c.46.33 1.13.34 1.59.03l3.67-2.43c.35-.23.44-.69.21-1.04a.755.755 0 0 0-1.04-.21l-3.61 2.4L3.07 3.5H14.5v8.94h-13V5.97a.749.749 0 1 0-1.5 0v6.77c0 .66.54 1.2 1.2 1.2h13.6c.66 0 1.2-.54 1.2-1.2V3.2c0-.66-.54-1.2-1.2-1.2"
                }
              )
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_3572)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) })
        ]
      }
    )
  }
));
o.displayName = "AgencyMailIcon";
export {
  o as AgencyMailIcon,
  o as default
};
//# sourceMappingURL=index.js.map
